var CarouselEspecials = function(){

    'use strict';

    var $ = jQuery;
    var instances = [];


    function onReady() {
        $('.module.carousel-specials').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Private properties
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        var $view = view,
            id = $view.data('id'),
            params = window.dataModules[id];

        $view.find('script').remove();



        // Private methods
        // * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

        // instance object
        var instance = {
            init: function () {
                initCarousel();
            }
        };

        var active = parseInt(params.active);

        console.log('esto es mi valor ' +  active);
        function initCarousel() {
            $view.find('#owl-carousel').owlCarousel({
                itemElement: 'item',
                loop: false,
                margin: 10,
                nav: true,
                navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
                scrollPerPage: 1,
                startPosition: active,
                responsive:{
                    0:{
                        items:1
                    },
                    479:{
                        items:1
                    },
                    768:{
                        items:2
                    },
                    979:{
                        items:3
                    },
                    1199:{
                        items:3
                    }
                },
                onInitialize: showCarrousel,
            });
        }


        function showCarrousel() {        
            $('.module.carousel-specials').css('display', 'block');
        }


        instance.init();
        return instance;
    }

    // DOMContentLoaded
    $(onReady);

}

CarouselEspecials();
